
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11697',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11697",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.451",
  "dashboard-client-types": "static-1.266",
  "data-fetching-client": "static-1.9524",
  "foundations-components": "static-1.7617",
  "foundations-components-legacy": "static-1.642",
  "foundations-theming": "static-1.4259",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7853",
  "hub-http-shared-msw-handlers": "static-1.9585",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11288",
  "I18n": "static-7.1583",
  "jasmine-runner": "static-1.6317",
  "marketplace-storefront-base": "static-1.11757",
  "quartz": "static-1.6795",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16497",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2711",
  "reporting-testing-lib": "static-1.8653",
  "settings-ui-lib": "static-1.12370",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6823",
  "ui-addon-i18n": "static-1.10991",
  "ui-addon-react-router-dom": "static-1.9392",
  "unified-auth": "static-1.278",
  "unified-auth-core-lib": "static-1.559",
  "usage-tracker": "static-1.7182",
  "usage-tracker-core": "static-1.7032",
  "customer-data-property-utils": "static-1.7928",
  "history": "static-4.47",
  "hub-http": "static-1.6064",
  "integrations-lib": "static-1.15575",
  "marketplace-ui-common": "static-1.19077",
  "property-management-iframe": "static-1.12531",
  "quartz-config": "static-1.573",
  "quartz-core": "static-1.6014",
  "quartz-routing": "static-1.225",
  "quick-fetch": "static-1.3781",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4486",
  "ts-schema": "static-1.3948",
  "ui-universal-auth": "static-1.8764",
  "UIComponents": "static-3.8235",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3273",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3072",
  "quartz-webpack": "static-1.3019",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3886",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4686",
  "foundations-theming-specialty": "static-1.1975",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9273",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5217",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1343",
  "ui-fonts": "static-1.550",
  "ui-images": "static-2.1109",
  "bend-plugin-foundations-theming": "static-1.2742",
  "foundations-theming-base": "static-1.3244",
  "stylex": "static-1.28",
  "HeadJS": "static-2.721",
  "hs-test-utils-bend-plugin": "static-1.2964",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4173",
  "ai-components-ui-library": "static-1.8483",
  "ai-rendering-library": "static-1.9448",
  "chirp-fetch": "static-1.1730",
  "connections-embed-lib": "static-1.705",
  "copilot-toolkit": "static-1.10653",
  "laboratory-lib": "static-3.7007",
  "marketplace-embed": "static-1.21595",
  "marketplace-ui-details": "static-1.8973",
  "marketplace-ui-reviews": "static-1.19033",
  "marketplace-ui-tracking": "static-1.13248",
  "sanitize-text": "static-1.7992",
  "ui-addon-video-player": "static-1.8543",
  "usage-tracker-multi": "static-1.5596",
  "usage-tracker-session-replay": "static-1.4868",
  "wootric-nps": "static-1.6829",
  "apollo-link-hub-http": "static-2.4498",
  "immer": "static-1.33",
  "immerable": "static-1.4001",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2391",
  "reporting-data": "static-1.66720",
  "cssUtils": "static-1.748",
  "flux-actions": "static-1.314",
  "HubStyle": "static-2.11596",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10058",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10221",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7172",
  "icons": "static-2.629",
  "marketplace-ui-apps-core": "static-1.17610",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4367",
  "foundations-components-test-utils": "static-1.5100",
  "quartz-i18n": "static-1.470",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3578",
  "customer-data-objects": "static-1.7498",
  "property-translator": "static-1.5257",
  "frontend-preferences-client": "static-1.7771",
  "hs-promise-utils": "static-1.5440",
  "hubspot-apollo-client": "static-1.4727",
  "integrations-error-boundary-lib": "static-1.12990",
  "integrations-tracking-lib": "static-1.5438",
  "native-integrations-shared-strings": "static-1.7635",
  "reselect": "static-2.16",
  "sanitize": "static-1.4321",
  "superstore": "static-1.4616",
  "ui-shepherd-react": "static-3.9993",
  "ai-settings-ui-library": "static-1.7595",
  "hub-http-janus": "static-1.806",
  "hubspotter-http": "static-1.4522",
  "immutable-less": "static-1.4501",
  "marketplace-ui-client-types": "static-1.16484",
  "nav-meta": "static-1.29064",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10089",
  "ui-addon-upgrades": "static-9.17723",
  "inbound-db-properties-service-client": "static-1.3715",
  "property-management-common": "static-1.4818",
  "ui-addon-iframeable": "static-1.8895",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.496",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.470",
  "quartz-head": "static-1.460",
  "quartz-test": "static-1.470",
  "quartz-tracking": "static-1.174",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2992",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20522",
  "ContentUtils": "static-1.67766",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2339",
  "customer-data-filters-ui": "static-1.39070",
  "customer-data-objects-ui-components": "static-1.12860",
  "customer-data-reference-ui-components": "static-1.12996",
  "embedded-academy-lib": "static-1.13718",
  "ExportDialog": "static-6.10234",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40776",
  "reporting-snowflake": "static-1.55338",
  "reporting-ui-components": "static-2.63991",
  "reporting-visualizations": "static-1.58796",
  "ui-addon-teams": "static-1.21305",
  "magpie-lib": "static-1.5441",
  "magpie-types": "static-1.4901",
  "simple-logging-lib": "static-1.2897",
  "navigation-components": "static-1.17427",
  "ai-studio-lib": "static-1.11122",
  "app-governance-lib": "static-1.1012",
  "developer-experience-shared-components": "static-1.10346",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7838",
  "ui-product-approvals": "static-1.27598",
  "ui-tool-access": "static-1.9992",
  "usage-based-billing-components-lib": "static-1.8138",
  "usage-tracker-anonymous": "static-1.5599",
  "usage-tracker-public": "static-1.6993",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3464",
  "persist-promise": "static-1.3556",
  "reference-resolvers": "static-1.8010",
  "ui-extensibility-client-types": "static-1.3789",
  "hubspot-apollo-cache": "static-1.186",
  "universal-page-editor-lib": "static-1.2849",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2310",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4918",
  "purchase-motions-components": "static-1.5541",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1399",
  "crm-component-utils": "static-1.38593",
  "crm-properties-common-lib": "static-1.5720",
  "customer-data-properties": "static-1.50912",
  "framework-data-schema-resolvers": "static-1.6721",
  "property-value-citations": "static-1.1527",
  "reference-resolvers-lite": "static-1.7930",
  "navigation-messaging": "static-1.6754",
  "hubspotter-http-shared-msw-handlers": "static-1.9583",
  "cms-field-types": "static-1.4656",
  "content-icons-ui": "static-1.2172",
  "conversations-skeleton-state": "static-1.7095",
  "crm-message-bus": "static-1.42502",
  "customer-data-filters-ui-msw-helpers": "static-1.21505",
  "customer-data-ui-utilities": "static-1.9671",
  "FormUrlGenerator": "static-2.4569",
  "framework-builder-read-service-client": "static-1.3876",
  "framework-data-schema-quick-fetch": "static-1.6626",
  "multi-account-reference-resolvers": "static-1.822",
  "onboarding-tours": "static-1.16332",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13192",
  "academy-common-lib": "static-1.13178",
  "content-assistance-lib": "static-1.7518",
  "dashboard-lib": "static-1.80822",
  "file-manager-components": "static-1.23040",
  "getting-started-shared-tasks": "static-1.18011",
  "hubspot-prosemirror": "static-1.17732",
  "hubspot-prosemirror-plugins": "static-1.17724",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19552",
  "share-with-third-party-component-lib": "static-1.8540",
  "ui-addon-draggable": "static-3.4614",
  "ui-asset-management-lib": "static-1.10773",
  "ui-business-units-lib": "static-1.8879",
  "user-context": "static-1.4947",
  "growth-payments-core": "static-1.24859",
  "reporting-plugins": "static-1.10037",
  "reporting-reports": "static-1.66398",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.572",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28960",
  "react-codemirror": "static-1.10473",
  "framework-listing-lib": "static-2-rr-react-compiler.25",
  "fuzzy": "static-1.8",
  "apps-service-types": "static-1.3724",
  "oauth-service-types": "static-1.4094",
  "onboarding-scopes": "static-1.6311",
  "onboarding-tours-client": "static-1.4546",
  "platform-infra-nav-components": "static-1.7536",
  "subscription-experience-data-types": "static-1.14646",
  "crm-record-cards-service-types": "static-1.3486",
  "location-customization-utils-lib": "static-1.8714",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4346",
  "nav-client-types": "static-1.2204",
  "purchase-motions-api": "static-1.5544",
  "signup-constants": "static-1.18510",
  "signup-ui-url-generator": "static-2.7882",
  "trials-service-types": "static-1.3747",
  "card-properties-lib": "static-1.43656",
  "commerce-subscription-lib": "static-1.36592",
  "crm-actions": "static-1.6154",
  "crm-cards-sdk": "static-1.43059",
  "customer-data-properties-shared-msw-handlers": "static-1.8912",
  "customer-data-tracking": "static-1.6730",
  "hs-entities": "static-1.530",
  "pulse": "static-1.368",
  "calling-global-api": "static-1.63846",
  "calling-internal-common": "static-1.31146",
  "calling-lifecycle-internal": "static-1.65228",
  "calling-lifecycle-messages": "static-1.57522",
  "commerce-products-lib": "static-1.8980",
  "conditional-properties-service-client": "static-1.3666",
  "crm-links": "static-1.6116",
  "external-options-client-types": "static-1.4027",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4092",
  "meetings-icalendar-utils-lib": "static-1.479",
  "multi-currency-client-types": "static-1.3560",
  "object-builder-ui-client": "static-1.48155",
  "pipeline-validation-client-types": "static-1.3833",
  "smart-property-lib": "static-1.6117",
  "tiered-pricing": "static-1.900",
  "ui-addon-form-validation": "static-1.10840",
  "crm-pipelines-api-client-types": "static-1.4008",
  "customer-data-associations": "static-1.7171",
  "customer-data-views-management": "static-1.25086",
  "framework-data-table": "static-2.11526",
  "marketing-platform-lib": "static-1.6692",
  "nudge-client-utils": "static-1.2260",
  "nudge-custom-ui-functions": "static-1.767",
  "react-dnd-compat": "static-1.4467",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5205",
  "growth-onboarding-confetti": "static-1.2919",
  "growth-onboarding-next-action-utils": "static-1.1417",
  "onboarding-tours-utils": "static-1.398",
  "ui-shepherd-tracker": "static-1.7374",
  "academy-service-client": "static-1.3527",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28067",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8230",
  "video-components-external": "static-1.10704",
  "video-data-lib": "static-1.34362",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23063",
  "ui-addon-emoji-picker": "static-1.9734",
  "EmailSignatureEditor": "static-1.23982",
  "viral-links-lib": "static-1.6885",
  "data-token-picker": "static-1.16123",
  "FileManagerLib": "static-1.38680",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5092",
  "getting-started-shared-tasks-store": "static-1.17129",
  "campaign-roi-lib": "static-1.8423",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.240",
  "eligibility-engine-service-types": "static-1.3028",
  "crm_data": "static-4.91401",
  "customer-data-sidebar": "static-2.45540",
  "enrichment-properties-lib": "static-1.15235",
  "commerce-billing-lib": "static-1.18621",
  "commerce-shared-components-lib": "static-1.18075",
  "commerce-tools-ui-lib": "static-1.9912",
  "crm-fe-perf": "static-1.22752",
  "directed-graph": "static-1.786",
  "event-emitter": "static-1.794",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31152",
  "shared-worker-versioning": "static-1.10886",
  "calling-usage-tracker": "static-1.6388",
  "voice-sms-access-library": "static-1.383",
  "commerce-permissions": "static-1.611",
  "products-iframe-lib": "static-1.7454",
  "products-ui-components-shared-msw-handlers": "static-1.9967",
  "breeze-intelligence-kit": "static-1.5391",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9668",
  "policy-lib": "static-1.6624",
  "react-tinymce": "static-1.54751",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9731",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53877",
  "tinymce-plugins": "static-1.56991",
  "tinymce-themes": "static-1.55847",
  "crm-export-dialog": "static-1.6139",
  "crm-index-associations-lib": "static-1.6283",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1427",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2017",
  "nudge-renderer-utils": "static-1.2336",
  "whisper-core-api": "static-1.6124",
  "InboxConnectUtils": "static-4.14343",
  "growth-onboarding-next-action-components": "static-1.1445",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6428",
  "content-media-composition-data-lib": "static-1.11627",
  "content-media-compositions": "static-2.15634",
  "media-bridge-lib": "static-1.18644",
  "commerce-tours-lib": "static-1.5790",
  "growth-onboarding-reliability": "static-1.4934",
  "sales-checkout-service-client": "static-1.3514",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21388",
  "sales-email-signature-service-client": "static-1.3691",
  "audio-components": "static-1.5682",
  "FileManagerCore": "static-1.38539",
  "FileManagerImages": "static-1.36191",
  "video-components": "static-1.12707",
  "crm_universal": "static-1.21738",
  "customer-data-email": "static-1.17750",
  "card-payment-highlight-lib": "static-1.36645",
  "card-subscription-highlight-lib": "static-1.39015",
  "commerce-contract-lib": "static-1.11367",
  "customer-data-content": "static-1.26959",
  "invoices-highlight-card-lib": "static-1.54180",
  "orders-highlight-card-lib": "static-1.20985",
  "products-highlight-card-lib": "static-1.17264",
  "project-storage": "static-1.4581",
  "quotes-highlight-card-lib": "static-1.71353",
  "crm-source-interpretation-lib": "static-1.5179",
  "utility-belt": "static-1.2387",
  "payments-enrollment-embed-lib": "static-1.22148",
  "customer-data-rte": "static-1.32558",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5438",
  "payments-post-enroll-local-storage-lib": "static-1.4961",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37442",
  "calling-orchestration-schema": "static-1.35160",
  "sales-views-client-types": "static-1.4133",
  "hub-http-contrib": "static-1.2890",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39962",
  "ui-addon-sales-email": "static-1.5061",
  "layout-dnd-components": "static-1.12129",
  "layout-dnd-utils": "static-1.11104",
  "ui-brand-identity-lib": "static-1.14218",
  "NamespacedHubStyle": "static-2.8939",
  "deal-intel-utils": "static-1.1431",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4379",
  "video-embed": "static-1.35196",
  "social-insights-client-types": "static-1.21504",
  "sequences-lib": "static-1.7762",
  "ui-gdpr-components": "static-1.10194",
  "products-ui-components": "static-1.39499",
  "quotes-ui-lib": "static-1.80073",
  "SalesContentIndexUI": "static-3.8974",
  "accounting-integrations-ui-components": "static-1.6801",
  "invoices-ui-lib": "static-1.54196",
  "commerce-products-api": "static-1.2026",
  "SafeStorage": "static-1.4249",
  "invoices-iframe-lib": "static-1.56254",
  "quotes-modal-lib": "static-1.102030",
  "stripe-embedded-components": "static-1.7218",
  "draft-content-plugins": "static-1.27825",
  "ContentData": "static-1.67841",
  "layout-data-lib": "static-1.9429",
  "outpost": "static-1.4048",
  "sequences-client-types-lib": "static-1.7619",
  "commerce-tax-lib": "static-1.364",
  "property-description-translator": "static-1.3703",
  "FireAlarmUi": "static-1.4376",
  "sales-templates-service-types-lib": "static-1.4035",
  "commerce-analytics-service-client": "static-1.3502",
  "totals-ui-components": "static-1.23113",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14887",
  "advanced-menus-lib": "static-1.11856",
  "ui-memberships-settings-lib": "static-1.33574",
  "commerce-totals-service-types": "static-1.3685",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14886",
  "simple-menus-lib": "static-1.16403"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11697",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.451",
  "dashboard-client-types": "/dashboard-client-types/static-1.266",
  "data-fetching-client": "/data-fetching-client/static-1.9524",
  "foundations-components": "/foundations-components/static-1.7617",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.642",
  "foundations-theming": "/foundations-theming/static-1.4259",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7853",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9585",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11288",
  "I18n": "/I18n/static-7.1583",
  "jasmine-runner": "/jasmine-runner/static-1.6317",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11757",
  "quartz": "/quartz/static-1.6795",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16497",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2711",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8653",
  "settings-ui-lib": "/settings-ui-lib/static-1.12370",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6823",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10991",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9392",
  "unified-auth": "/unified-auth/static-1.278",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.559",
  "usage-tracker": "/usage-tracker/static-1.7182",
  "usage-tracker-core": "/usage-tracker-core/static-1.7032",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7928",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6064",
  "integrations-lib": "/integrations-lib/static-1.15575",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19077",
  "property-management-iframe": "/property-management-iframe/static-1.12531",
  "quartz-config": "/quartz-config/static-1.573",
  "quartz-core": "/quartz-core/static-1.6014",
  "quartz-routing": "/quartz-routing/static-1.225",
  "quick-fetch": "/quick-fetch/static-1.3781",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4486",
  "ts-schema": "/ts-schema/static-1.3948",
  "ui-universal-auth": "/ui-universal-auth/static-1.8764",
  "UIComponents": "/UIComponents/static-3.8235",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3273",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3072",
  "quartz-webpack": "/quartz-webpack/static-1.3019",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3886",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4686",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1975",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9273",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5217",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1343",
  "ui-fonts": "/ui-fonts/static-1.550",
  "ui-images": "/ui-images/static-2.1109",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2742",
  "foundations-theming-base": "/foundations-theming-base/static-1.3244",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.721",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2964",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4173",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8483",
  "ai-rendering-library": "/ai-rendering-library/static-1.9448",
  "chirp-fetch": "/chirp-fetch/static-1.1730",
  "connections-embed-lib": "/connections-embed-lib/static-1.705",
  "copilot-toolkit": "/copilot-toolkit/static-1.10653",
  "laboratory-lib": "/laboratory-lib/static-3.7007",
  "marketplace-embed": "/marketplace-embed/static-1.21595",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8973",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19033",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13248",
  "sanitize-text": "/sanitize-text/static-1.7992",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8543",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5596",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4868",
  "wootric-nps": "/wootric-nps/static-1.6829",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4498",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4001",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2391",
  "reporting-data": "/reporting-data/static-1.66720",
  "cssUtils": "/cssUtils/static-1.748",
  "flux-actions": "/flux-actions/static-1.314",
  "HubStyle": "/HubStyle/static-2.11596",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10058",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10221",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7172",
  "icons": "/icons/static-2.629",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17610",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4367",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5100",
  "quartz-i18n": "/quartz-i18n/static-1.470",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3578",
  "customer-data-objects": "/customer-data-objects/static-1.7498",
  "property-translator": "/property-translator/static-1.5257",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7771",
  "hs-promise-utils": "/hs-promise-utils/static-1.5440",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4727",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12990",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5438",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7635",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4321",
  "superstore": "/superstore/static-1.4616",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9993",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7595",
  "hub-http-janus": "/hub-http-janus/static-1.806",
  "hubspotter-http": "/hubspotter-http/static-1.4522",
  "immutable-less": "/immutable-less/static-1.4501",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16484",
  "nav-meta": "/nav-meta/static-1.29064",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10089",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17723",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3715",
  "property-management-common": "/property-management-common/static-1.4818",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8895",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.496",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.470",
  "quartz-head": "/quartz-head/static-1.460",
  "quartz-test": "/quartz-test/static-1.470",
  "quartz-tracking": "/quartz-tracking/static-1.174",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20522",
  "ContentUtils": "/ContentUtils/static-1.67766",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2339",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39070",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12860",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12996",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13718",
  "ExportDialog": "/ExportDialog/static-6.10234",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40776",
  "reporting-snowflake": "/reporting-snowflake/static-1.55338",
  "reporting-ui-components": "/reporting-ui-components/static-2.63991",
  "reporting-visualizations": "/reporting-visualizations/static-1.58796",
  "ui-addon-teams": "/ui-addon-teams/static-1.21305",
  "magpie-lib": "/magpie-lib/static-1.5441",
  "magpie-types": "/magpie-types/static-1.4901",
  "simple-logging-lib": "/simple-logging-lib/static-1.2897",
  "navigation-components": "/navigation-components/static-1.17427",
  "ai-studio-lib": "/ai-studio-lib/static-1.11122",
  "app-governance-lib": "/app-governance-lib/static-1.1012",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10346",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7838",
  "ui-product-approvals": "/ui-product-approvals/static-1.27598",
  "ui-tool-access": "/ui-tool-access/static-1.9992",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8138",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5599",
  "usage-tracker-public": "/usage-tracker-public/static-1.6993",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3464",
  "persist-promise": "/persist-promise/static-1.3556",
  "reference-resolvers": "/reference-resolvers/static-1.8010",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3789",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.186",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2849",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2310",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4918",
  "purchase-motions-components": "/purchase-motions-components/static-1.5541",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1399",
  "crm-component-utils": "/crm-component-utils/static-1.38593",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5720",
  "customer-data-properties": "/customer-data-properties/static-1.50912",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6721",
  "property-value-citations": "/property-value-citations/static-1.1527",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7930",
  "navigation-messaging": "/navigation-messaging/static-1.6754",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9583",
  "cms-field-types": "/cms-field-types/static-1.4656",
  "content-icons-ui": "/content-icons-ui/static-1.2172",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7095",
  "crm-message-bus": "/crm-message-bus/static-1.42502",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21505",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9671",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4569",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3876",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6626",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.822",
  "onboarding-tours": "/onboarding-tours/static-1.16332",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13192",
  "academy-common-lib": "/academy-common-lib/static-1.13178",
  "content-assistance-lib": "/content-assistance-lib/static-1.7518",
  "dashboard-lib": "/dashboard-lib/static-1.80822",
  "file-manager-components": "/file-manager-components/static-1.23040",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18011",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17732",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17724",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19552",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8540",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4614",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10773",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8879",
  "user-context": "/user-context/static-1.4947",
  "growth-payments-core": "/growth-payments-core/static-1.24859",
  "reporting-plugins": "/reporting-plugins/static-1.10037",
  "reporting-reports": "/reporting-reports/static-1.66398",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.572",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28960",
  "react-codemirror": "/react-codemirror/static-1.10473",
  "framework-listing-lib": "/framework-listing-lib/static-2-rr-react-compiler.25",
  "fuzzy": "/fuzzy/static-1.8",
  "apps-service-types": "/apps-service-types/static-1.3724",
  "oauth-service-types": "/oauth-service-types/static-1.4094",
  "onboarding-scopes": "/onboarding-scopes/static-1.6311",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4546",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7536",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14646",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3486",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8714",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4346",
  "nav-client-types": "/nav-client-types/static-1.2204",
  "purchase-motions-api": "/purchase-motions-api/static-1.5544",
  "signup-constants": "/signup-constants/static-1.18510",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7882",
  "trials-service-types": "/trials-service-types/static-1.3747",
  "card-properties-lib": "/card-properties-lib/static-1.43656",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36592",
  "crm-actions": "/crm-actions/static-1.6154",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43059",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8912",
  "customer-data-tracking": "/customer-data-tracking/static-1.6730",
  "hs-entities": "/hs-entities/static-1.530",
  "pulse": "/pulse/static-1.368",
  "calling-global-api": "/calling-global-api/static-1.63846",
  "calling-internal-common": "/calling-internal-common/static-1.31146",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65228",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57522",
  "commerce-products-lib": "/commerce-products-lib/static-1.8980",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3666",
  "crm-links": "/crm-links/static-1.6116",
  "external-options-client-types": "/external-options-client-types/static-1.4027",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4092",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.479",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3560",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48155",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3833",
  "smart-property-lib": "/smart-property-lib/static-1.6117",
  "tiered-pricing": "/tiered-pricing/static-1.900",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10840",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4008",
  "customer-data-associations": "/customer-data-associations/static-1.7171",
  "customer-data-views-management": "/customer-data-views-management/static-1.25086",
  "framework-data-table": "/framework-data-table/static-2.11526",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6692",
  "nudge-client-utils": "/nudge-client-utils/static-1.2260",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.767",
  "react-dnd-compat": "/react-dnd-compat/static-1.4467",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5205",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2919",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1417",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.398",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7374",
  "academy-service-client": "/academy-service-client/static-1.3527",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28067",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8230",
  "video-components-external": "/video-components-external/static-1.10704",
  "video-data-lib": "/video-data-lib/static-1.34362",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23063",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9734",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23982",
  "viral-links-lib": "/viral-links-lib/static-1.6885",
  "data-token-picker": "/data-token-picker/static-1.16123",
  "FileManagerLib": "/FileManagerLib/static-1.38680",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5092",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17129",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8423",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.240",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3028",
  "crm_data": "/crm_data/static-4.91401",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45540",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15235",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18621",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18075",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9912",
  "crm-fe-perf": "/crm-fe-perf/static-1.22752",
  "directed-graph": "/directed-graph/static-1.786",
  "event-emitter": "/event-emitter/static-1.794",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31152",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10886",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6388",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.383",
  "commerce-permissions": "/commerce-permissions/static-1.611",
  "products-iframe-lib": "/products-iframe-lib/static-1.7454",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9967",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5391",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9668",
  "policy-lib": "/policy-lib/static-1.6624",
  "react-tinymce": "/react-tinymce/static-1.54751",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9731",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53877",
  "tinymce-plugins": "/tinymce-plugins/static-1.56991",
  "tinymce-themes": "/tinymce-themes/static-1.55847",
  "crm-export-dialog": "/crm-export-dialog/static-1.6139",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6283",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1427",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2017",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2336",
  "whisper-core-api": "/whisper-core-api/static-1.6124",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14343",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1445",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6428",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11627",
  "content-media-compositions": "/content-media-compositions/static-2.15634",
  "media-bridge-lib": "/media-bridge-lib/static-1.18644",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5790",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4934",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3514",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21388",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3691",
  "audio-components": "/audio-components/static-1.5682",
  "FileManagerCore": "/FileManagerCore/static-1.38539",
  "FileManagerImages": "/FileManagerImages/static-1.36191",
  "video-components": "/video-components/static-1.12707",
  "crm_universal": "/crm_universal/static-1.21738",
  "customer-data-email": "/customer-data-email/static-1.17750",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36645",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39015",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11367",
  "customer-data-content": "/customer-data-content/static-1.26959",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54180",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20985",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17264",
  "project-storage": "/project-storage/static-1.4581",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71353",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5179",
  "utility-belt": "/utility-belt/static-1.2387",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22148",
  "customer-data-rte": "/customer-data-rte/static-1.32558",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5438",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4961",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37442",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35160",
  "sales-views-client-types": "/sales-views-client-types/static-1.4133",
  "hub-http-contrib": "/hub-http-contrib/static-1.2890",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39962",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5061",
  "layout-dnd-components": "/layout-dnd-components/static-1.12129",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11104",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14218",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8939",
  "deal-intel-utils": "/deal-intel-utils/static-1.1431",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4379",
  "video-embed": "/video-embed/static-1.35196",
  "social-insights-client-types": "/social-insights-client-types/static-1.21504",
  "sequences-lib": "/sequences-lib/static-1.7762",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10194",
  "products-ui-components": "/products-ui-components/static-1.39499",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80073",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8974",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6801",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54196",
  "commerce-products-api": "/commerce-products-api/static-1.2026",
  "SafeStorage": "/SafeStorage/static-1.4249",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56254",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102030",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7218",
  "draft-content-plugins": "/draft-content-plugins/static-1.27825",
  "ContentData": "/ContentData/static-1.67841",
  "layout-data-lib": "/layout-data-lib/static-1.9429",
  "outpost": "/outpost/static-1.4048",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7619",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.364",
  "property-description-translator": "/property-description-translator/static-1.3703",
  "FireAlarmUi": "/FireAlarmUi/static-1.4376",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4035",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3502",
  "totals-ui-components": "/totals-ui-components/static-1.23113",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14887",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11856",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33574",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3685",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14886",
  "simple-menus-lib": "/simple-menus-lib/static-1.16403"
}
};
